
import Auth from "@/lib/common/auth";
import { Component, Vue, Watch } from "vue-property-decorator";
import vuexStore from "@/store/vuex-store";
import { CompanyConfig } from "@/lib/common/acm";

@Component({})
export default class SideLayout extends Vue {
  hoverIndex = 1;
  currentCompanyId = 0;
  showVirtualAvatarMenu = false;
  currentIndex = 1; //当前菜单栏  --当前使用

  @Watch("$route", { deep: true })
  changeSideLog() {
    this.activeIt();
  }

  get setWeb(): boolean {
    return this.$route?.query?.teamUse === "setWeb";
  }

  mounted() {
    this.activeIt();
    const companyConfig = CompanyConfig.getInstance(parseInt(Auth.companyId));
    this.currentCompanyId = parseInt(Auth.companyId);
    this.showVirtualAvatarMenu = companyConfig.showVirtualAvatarMenu == 1;
  }

  // 高亮
  activeIt() {
    switch (String(this?.$route?.name)) {
      case "dash-comp":
        this.currentIndex = 1;
        break;
      case "exam-component-paper":
      case "exam-component-candidate":
      case "ai-builder-component":
        this.currentIndex = 2;
        break;
      case "candidate-component-list":
        this.currentIndex = 3;
        break;
      case "ai-question-store-comp":
        this.currentIndex = 4;
        break;
      case "message-comp-list":
      case "message-temp-comp-list":
        this.currentIndex = 5;
        break;
      case "export-component-list":
        this.currentIndex = 6;
        break;
      case "ai-qa-list-comp":
        this.currentIndex = 7;
        break;
      case "company-config-comp":
        this.currentIndex = 8;
        break;

      default:
        this.currentIndex = 2; //其余页面目前都是2的子页面
    }
  }

  // 跳转
  pathTo(to: any) {
    if (this.$route.path === to) return;
    this.$router.push(to);
  }
}
